<template>
  <div v-if="hasPermission(permissions.depositsCreate)">
    <content-header>{{ $t('createDeposit') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <select-input
                id="depositType"
                :name="$t('depositType')"
                :validate="$v"
                :required="true"
                api-link="depositTypes/GET_ALL"
                label="name"
                @itemSelected="e => form.depositTypeId = e"
            />
            <select-input
                id="safeBox"
                :name="$t('safeBox')"
                :validate="$v"
                :required="true"
                api-link="safeBoxes/GET_ALL"
                label="name"
                @itemSelected="e => form.safeboxId = e"
            />
            <number-input id="mcPrice" :name="$t('price')" :show-locale-string="true" :validate="$v" :required="true" :is-loading="isLoading" />
            <text-input id="accountant" :name="$t('accountant')" :validate="$v" :is-loading="isLoading" />
            <text-input id="depositer" :name="$t('depositer')" :validate="$v" :is-loading="isLoading" />
            <date-time-input id="date" :name="$t('date')" :default-value="getCurrentDate()" :validate="$v" :required="true" :is-loading="isLoading" />
            <text-area-input id="note" :name="$t('note')" :validate="$v" :is-loading="isLoading" />
            <file-input
                id="attachment"
                :name="$t('attachment')"
                @fileAdded="base64File => form.attachment = base64File"
            />
            <submit-input :name="$t('create')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required, maxLength } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {Deposit} from "@/models/Deposit";
import SubmitInput from "@/components/Inputs/SubmitInput";
import FileInput from "@/components/Inputs/FileInput";
import SelectInput from "@/components/Inputs/SelectInput";
import TextInput from "@/components/Inputs/TextInput";
import NumberInput from "@/components/Inputs/NumberInput";
import DateTimeInput from "@/components/Inputs/DateTimeInput";
import TextAreaInput from "@/components/Inputs/TextAreaInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "DepositCreate",
  components: {TextAreaInput, DateTimeInput, NumberInput, TextInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading, FileInput, SelectInput},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new Deposit().fillAbles),
      isLoading: false,
      selectedItem: {},
      permissions: permissions
    }
  },
  validations: {
    form: {
      name: {required, maxLength: maxLength(255)},
      depositTypeId: {required},
      safeboxId: {required},
      mcPrice: {required},
      date: {required},
      accountant: {},
      depositer: {},
      note: {},
      attachment: {},
    }
  },
  methods: {
    onSubmit() {
      delete this.form.mcTotalPrice;
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('deposits/CREATE', this.form).then(() => {
        this.$v.$reset();
        this.$router.push({name: "deposits"})
      }).catch(() => this.isLoading = false);
    },
  }
}
</script>
